export default __webpack_public_path__ + "static/media/sign-out.c33abcb4.svg";